import {
  Briefcase,
  ContactRound,
  FileText,
  Hash,
  Headset,
  PackageOpen,
  Store,
} from "lucide-react"
import type { IAccount } from "@apis/accounts/types"
import type { IOrder } from "@commonTypes/order"
import { formatDate } from "@utils/formatters"

type TSalesInfoProps = {
  account: IAccount
  order: IOrder
}

const SalesInfo = ({ account, order }: TSalesInfoProps) => {
  function formatBoldKeys(text: string): string {
    if (!text) return ""

    let formattedText = text.replace(/^([^:]+):/, (_, key) => {
      return `<strong>${key}</strong>:`
    })

    formattedText = formattedText.replace(/- ([^:]+):/g, (_, key) => {
      return `- <strong>${key}</strong>:`
    })

    return formattedText
  }

  const salesInfoItems = [
    {
      title: "Member Number",
      info: account.member_number,
      icon: Hash,
    },
    {
      title: "Order Number",
      info: order.order_id,
      icon: FileText,
    },
    {
      title: "Signed Up Via",
      info: formatBoldKeys(order.signed_up_description),
      icon: Briefcase,
      dangerousHTML: true,
    },
    {
      title: null,
      info: order.source_description,
      icon: Store,
    },
    {
      title: "Account Contact",
      info: [account.first_name, account.last_name].filter(Boolean).join(" "),
      icon: ContactRound,
      hidden: !(
        account.contact_first_name &&
        (account.contact_first_name !== account.first_name ||
          account.contact_last_name !== account.last_name)
      ),
    },
    {
      title: "Sales Agent",
      info: [order.agent_name, order.agent_id].filter(Boolean).join(" "),
      icon: Headset,
      hidden: !order.sales_agent,
    },
    {
      title: "Office",
      info: order.sales_agent?.office_code,
      icon: Store,
      hidden: !order.sales_agent?.office_code,
    },
    {
      title: "Moved in Date",
      info: order.move_in_date && formatDate(order.move_in_date),
      icon: PackageOpen,
      hidden: !order.move_in_date,
    },
  ]

  return (
    <div>
      <h3 className="mb-2">Sales Information</h3>
      <ul className="tw:flex tw:list-none tw:flex-col tw:gap-1 tw:p-0">
        {salesInfoItems.map((item, key) => {
          const Icon = item.icon
          return (
            <>
              {!item.hidden && (
                <li
                  key={`${item.info}-${key}`}
                  className="tw:flex tw:items-start"
                >
                  <Icon size={16} className="tw:m-1 tw:inline-block" />
                  <span>
                    {item.dangerousHTML ? (
                      <span
                        dangerouslySetInnerHTML={{
                          __html: `${item.title}: ${item.info}` as string,
                        }}
                      />
                    ) : (
                      <>
                        {item.title && `${item.title}:`} {item.info}
                      </>
                    )}
                  </span>
                </li>
              )}
            </>
          )
        })}
      </ul>
    </div>
  )
}

export default SalesInfo
